import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import DashView from '../views/Dash.vue'

import { TokenService, UserInfo }  from '../services/storage.service'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: () => {

      const loggedIn = !!TokenService.getToken();

      if (!loggedIn || UserInfo.get() == null){
        localStorage.removeItem('access_token');
        return "/login";
      }else{
        return "/home";
      }

    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/home',
    component: DashView,
    children: [
      {
        path: '/',
        name: 'home',
        component: Home,
        meta: {requireAuth:true},
      }
    ]
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

router.beforeEach((to, from, next) => {

  const ProtectedRoute = to.matched.some(record => record.meta.requireAuth)

  if(ProtectedRoute && (TokenService.getToken()=="" || TokenService.getToken()==null)){

    next({name: 'login'})

  }else{

    next();

  }

})

export default router;
